// PIN screen (unlock.html). The edge gate shows it in place of any page when the
// visitor has no active access. A correct PIN sets the access cookie; then we
// reload the page they asked for (or go home when opened as /unlock.html).

import "./styles/styles.css";

const form = document.getElementById("form") as HTMLFormElement;
const pinEl = document.getElementById("pin") as HTMLInputElement;
const goBtn = document.getElementById("go") as HTMLButtonElement;
const msg = document.getElementById("msg")!;

function show(text: string): void {
  msg.textContent = text;
  msg.classList.toggle("show", !!text);
}

if (new URLSearchParams(location.search).has("used")) {
  show("This link has already been used or is no longer valid.");
}

pinEl.addEventListener("input", () => { pinEl.value = pinEl.value.replace(/\D/g, "").slice(0, 4); });

form.addEventListener("submit", async (e) => {
  e.preventDefault();
  const pin = pinEl.value;
  if (!/^\d{4}$/.test(pin)) return show("Enter the 4 digits of your PIN.");

  goBtn.disabled = true;
  show("");
  try {
    const res = await fetch("/api/unlock", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pin }),
    });
    if (res.ok) {
      if (location.pathname.endsWith("unlock.html")) location.href = "/";
      else location.reload();
      return;
    }
    show(res.status === 429 ? "Too many attempts. Please try again later." : "Wrong PIN, or it has already been used.");
  } catch {
    show("Something went wrong. Please try again.");
  }
  goBtn.disabled = false;
  pinEl.select();
});
